import { Component, forwardRef, Inject } from '@angular/core';
import { DialogCloseReason, DialogBase, IDialogOnClose } from '../base-dialog';
import { DialogService } from '../dialog.service';

@Component({
  selector: 'alert-dialog',
  templateUrl: 'alert.html'
})
export class AlertDialogComponent extends DialogBase {

  okCaption: string;
  hideFooterButtons: boolean;
  constructor() {
    super();
  }

  initDialog() {
    this.okCaption = this.extraData.okCaption ? this.extraData.okCaption : 'OK';
    this.hideFooterButtons = this.extraData.hideFooterButtons ? this.extraData.hideFooterButtons : false;
  }

  getTypeClass(): string {
    switch (<EAlertTypes>this.extraData.type) {
      case EAlertTypes.Error:
        return 'error';
      case EAlertTypes.Warning:
        return 'warning';
    }
    return '';
  }

  closeAlert() {
    this.close({ reason: DialogCloseReason.OK });
  }

}

export interface IAlertData {
  header: string;
  message: string;
  secondMessage?: string;
  type?: EAlertTypes;
  okCaption?: string;
  hideFooterButtons?: boolean;
}

export enum EAlertTypes {
  Alert,
  Warning,
  Error
}
